/**
 * @deprecated: [Priyanshu] axios has inbuilt support for this, will remove this function
 * */
export const isResponseOk = (response) => {
	return [200, 201, 204, 301, 302].indexOf(response.status) !== -1;
};
